import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "@fontsource/roboto/400";
import "@fontsource/roboto/500";
import "@fontsource/roboto/700";
import "@fontsource/roboto-mono/400";
import "@wayfarer/components/css";
import "./app.css";
import './components/home/ToDo.css';
import { Suspense, lazy, useEffect } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import GlobalSpinner, { useGlobalSpinner } from "./GlobalSpinner";
import Auth from "./Auth";
import Shell from "./Shell";
import SignedOut from "./SignedOut";
import SelectRegion from "./SelectRegion";
import useHash from "./useHash";
import ConfigurationError from "./ConfigurationError";
import SearchResultsDetail from "./components/contentPortal/SearchResultsDetail";
import { AlertToastOutlet } from "@wayfarer/components";
import LoginInternal from "./components/login/login-internal";
import LoginNAB from "./components/login/login-NAB";
import LoginEUB from "./components/login/login-EUB";
import DocumentRepository from "./components/orderGuide/client/DocumentRepository";
import FunckyUI from "./components/orderGuide/pheonixTaskPopups/FunckyUI";
var SearchV2 = lazy(function () { return import("./components/search/SearchResults"); });
// const HomePage = lazy(() => import("./HomePage"));
var SearchResults = lazy(function () { return import("./SearchResults"); });
var SearchResultsDetailPage = lazy(function () { return import("./components/contentPortal/SearchResultsDetail"); });
// const ClientPage = lazy(() => import("./components/client/ClientPage"));
var HomePageOG = lazy(function () { return import("./components/orderGuide/home/HomePageOG"); });
var ClientPageOG = lazy(function () { return import("./components/orderGuide/client/ClientPage"); });
// const ContentPortalPage = lazy(() => import("./components/contentPortal/ContentPortal"));
var ContentPortalHome = lazy(function () { return import("./components/contentPortal/HomeCP"); });
var ContentPortalProductDocuments = lazy(function () { return import("./components/contentPortal/ProductDocuments"); });
var ContentPortalDocumentViewer = lazy(function () { return import("./components/contentPortal/DocumentViewer"); });
var Error404 = lazy(function () { return import("./404"); });
var NOAccess = lazy(function () { return import("./accessdenied"); });
var SearchDocumentViewer = lazy(function () { return import("./components/contentPortal/SearchDocumentViewer"); });
var ReportDetail = lazy(function () { return import("./components/reports/Reports"); });
var ReportsHome = lazy(function () { return import("./components/reports/ReportsHome"); });
// * Report revamp start *
var ReportDetailV2 = lazy(function () { return import("./components/reports-v2/Reports"); });
var ReportsHomeV2 = lazy(function () { return import("./components/reports-v2/ReportsHome"); });
// * Report revamp end *
export default function App() {
    // const { showSpinner } = useGlobalSpinner();
    // Global effect to remove tabIndex from Dialog elements when they open
    // useEffect(() => {
    //   const observer = new MutationObserver((mutations) => {
    //     mutations.forEach((mutation) => {
    //       if (mutation.type === 'childList') {
    //         mutation.addedNodes.forEach((node) => {
    //           if (node.nodeType === Node.ELEMENT_NODE) {
    //             // const element = node as Element;
    //             // // Check if it's a Dialog element (adjust selector based on library)
    //             // if (element.querySelector('.wyfr-modal___layer') || element.matches('[role="dialog"]') || element.classList.contains('dialog') || element.tagName.toLowerCase() === 'dialog') {
    //             //   element.removeAttribute('tabindex');
    //             // }
    //             // // Also check children in case the dialog is nested
    //             // element.querySelectorAll('.wyfr-modal___layer, [role="dialog"], .dialog, dialog').forEach((dialogEl) => {
    //             //   dialogEl.removeAttribute('tabindex');
    //             // });
    //             const elementsToFix = document.querySelectorAll(`
    //       .wyfr-modal___layer,
    //       [aria-modal="true"],
    //       [tabindex="-1"][aria-modal="true"],
    //       [class*="wyfr-modal___layer"],
    //       [role="dialog"]
    //     `);
    //             console.log("Found elements to fix:", elementsToFix);
    //             elementsToFix.forEach((element) => {
    //               if (element.hasAttribute('tabindex')) {
    //                 element.removeAttribute('tabindex');
    //                 console.log("Removed tabindex from:", element.className || element.tagName);
    //               }
    //             });
    //           }
    //         });
    //       } else if (mutation.type === 'attributes' && mutation.attributeName === 'tabindex') {
    //         const element = mutation.target as Element;
    //         if (element.matches('.wyfr-modal___layer, [role="dialog"], .dialog, dialog')) {
    //           element.removeAttribute('tabindex');
    //         }
    //       }
    //     });
    //   });
    //   observer.observe(document.body, {
    //     childList: true,
    //     subtree: true,
    //     attributes: true,
    //     attributeFilter: ['tabindex'],
    //   });
    //   // Cleanup on unmount
    //   return () => observer.disconnect();
    // }, []);
    var hash = useHash();
    if (hash.startsWith("#/configuration-error")) {
        return _jsx(ConfigurationError, {});
    }
    if (hash === "#/signout") {
        return _jsx(SignedOut, {});
    }
    if (hash === "#/select-region") {
        return _jsx(SelectRegion, {});
    }
    if (hash === "#/loginInternal") {
        return _jsx(LoginInternal, {});
    }
    if (hash === "#/loginNA") {
        return _jsx(LoginNAB, {});
    }
    if (hash === "#/loginUK") {
        return _jsx(LoginEUB, {});
    }
    return (_jsx(Auth, { children: _jsxs(GlobalSpinner, { children: [_jsx(AlertToastOutlet, {}), _jsx(Routing, {})] }) }));
}
function Routing() {
    var spinner = useGlobalSpinner();
    return (_jsx(HashRouter, { children: _jsx(Routes, { children: _jsxs(Route, { path: "", element: _jsx(Shell, {}), children: [_jsx(Route, { path: "/", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(HomePageOG, {}) }) }), _jsx(Route, { path: "/search", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(SearchV2, {}) }) }), _jsx(Route, { path: "/search-legacy", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(SearchResults, {}) }) }), _jsx(Route, { path: "/searchDetail/:articleUri", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(SearchResultsDetail, {}) }) }), _jsx(Route, { path: "/funcky/:funckyUri", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(FunckyUI, {}) }) }), _jsx(Route, { path: "/client-legacy/:clientProductId/:sysUser", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }) }) }), _jsx(Route, { path: "/reports-v1", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(ReportsHome, {}) }) }), _jsx(Route, { path: "/reports-v1/:report/:pageName", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(ReportDetail, {}) }) }), _jsx(Route, { path: "/reports", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(ReportsHomeV2, {}) }) }), _jsx(Route, { path: "/reports/:report/:pageName", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(ReportDetailV2, {}) }) }), _jsx(Route, { path: "/documentation-hub/:category?", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(ContentPortalHome, {}) }) }), _jsx(Route, { path: "/documentation-hub/:category/:product/:version?/:type?", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(ContentPortalProductDocuments, {}) }) }), _jsx(Route, { path: "/documentation-hub/:category/:product/:version/:type/:documentId", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(ContentPortalDocumentViewer, {}) }) }), _jsx(Route, { path: "/document/:documentId?", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(SearchDocumentViewer, {}) }) }), _jsx(Route, { path: "/healthCheck", element: "Hello World!" }), _jsx(Route, { path: "*", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(Error404, {}) }) }), _jsx(Route, { path: "/access-denied", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(NOAccess, {}) }) }), _jsx(Route, { path: "/homepage-legacy", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }) }) }), _jsx(Route, { path: "/onboarding/:requestNumber", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(ClientPageOG, {}) }) }), _jsx(Route, { path: "/onboarding/:requestNumber/:account/document-repository", element: _jsx(Suspense, { fallback: _jsx(Effect, { fn: spinner.busy }), children: _jsx(DocumentRepository, {}) }) })] }) }) }));
}
function Effect(_a) {
    var fn = _a.fn;
    useEffect(fn, [fn]);
    return null;
}
